import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllDepartment, getAllEmail } from "../../api/request/dashboard/dashboard";

export const fetchEmails = createAsyncThunk('emails/get', async (_, { getState, rejectWithValue }) => {
    try {
        const response = await getAllEmail();
        if (Array.isArray(response?.data)) {
            console.log("API Response:", response);
            const uniqueUsers = Array.from(new Set(response.data.map(email => email.senderUsername)))
                .map(username => {
                    const userDetails = response.data.find(email => email.senderUsername === username);
                    return {
                        id: username,
                        description: username,
                        senderType: userDetails?.senderType || "Unknown",
                    };
                });
                
            return { emails: response.data, users: uniqueUsers }
        } else {
            console.error("Unexpected response format:", response);
            return { emails: [], users: [] }
        }
    } catch (error) {
        console.error("Error fetching emails:", error);
        return { emails: [], users: [] }
    }
})

export const fetchAllDepartment = createAsyncThunk('department/get', async (_, { getState }) => {
    try {
        const clientId = getState().user?.userDetail?.id
        const { data } = await getAllDepartment(clientId);
        return data || [];
    } catch (err) {
        return []
    }
})